/**
 * @generated SignedSource<<3519bd2fda521fe2cc274edc6fd0ae16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type messageHelpers_viewer$data = {
  readonly promoCodeMessaging: boolean | null;
  readonly " $fragmentType": "messageHelpers_viewer";
};
export type messageHelpers_viewer$key = {
  readonly " $data"?: messageHelpers_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"messageHelpers_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "messageHelpers_viewer"
};

(node as any).hash = "3c33d31c1d6ce7266a596e6d9bbe6f23";

export default node;
